export default function VideoSection() {
  const steps = [
    {
      number: "01",
      icon: "ri-user-add-line",
      title: "Kostenlos registrieren",
      description: "Erstelle in 30 Sekunden deinen Account – mit E-Mail oder Pseudonym. Keine Kreditkarte erforderlich.",
      color: "from-teal-400 to-cyan-500"
    },
    {
      number: "02",
      icon: "ri-calendar-check-line",
      title: "Tägliche Check-ins",
      description: "Nimm dir 2-3 Minuten Zeit für deinen Check-in. Erfasse deine Stimmung, Energie und Fortschritte in allen Lebensbereichen.",
      color: "from-purple-400 to-indigo-500"
    },
    {
      number: "03",
      icon: "ri-target-line",
      title: "Ziele definieren",
      description: "Setze dir konkrete Ziele in bis zu 8 Lebensbereichen. Die KI hilft dir, realistische Meilensteine zu planen.",
      color: "from-orange-400 to-red-500"
    },
    {
      number: "04",
      icon: "ri-lightbulb-flash-line",
      title: "KI-Erkenntnisse erhalten",
      description: "Erhalte personalisierte Insights über deine Verhaltensmuster, Stärken und Entwicklungspotenziale.",
      color: "from-yellow-400 to-orange-500"
    }
  ];

  return (
    <section id="wie-es-funktioniert" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-play-circle-line mr-2"></i>
            So funktioniert's
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            In 4 einfachen Schritten zu mehr mentaler Stärke
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Starte noch heute deine persönliche Entwicklungsreise mit Mindshift AI. 
            Keine Vorkenntnisse erforderlich – die KI führt dich durch jeden Schritt.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-teal-300 to-transparent -z-10"></div>
              )}

              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-teal-200 h-full">
                {/* Number Badge */}
                <div className={`inline-block bg-gradient-to-br ${step.color} text-white text-2xl font-bold px-4 py-2 rounded-lg mb-4`}>
                  {step.number}
                </div>

                {/* Icon */}
                <div className={`w-14 h-14 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center mb-4`}>
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* YouTube Video */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video max-w-5xl mx-auto">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/CDjSEXwN3uQ"
            title="Mindshift AI Demo Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>

        {/* Platform Access */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">
            Nutze Mindshift AI auf allen Plattformen
          </h3>
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <a
              href="https://t.me/mindshift_ai_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white p-8 rounded-2xl hover:shadow-2xl transition-all hover:scale-105 cursor-pointer"
            >
              <i className="ri-telegram-line text-5xl mb-4"></i>
              <h4 className="text-2xl font-bold mb-2">Telegram Bot</h4>
              <p className="text-blue-50 mb-4">
                Schnelle Check-ins und KI-Coaching direkt in Telegram
              </p>
              <div className="inline-flex items-center text-white font-semibold">
                Jetzt starten <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </a>

            <a
              href="/dashboard"
              className="bg-gradient-to-r from-teal-500 to-emerald-500 text-white p-8 rounded-2xl hover:shadow-2xl transition-all hover:scale-105 cursor-pointer"
            >
              <i className="ri-dashboard-line text-5xl mb-4"></i>
              <h4 className="text-2xl font-bold mb-2">Web-Dashboard</h4>
              <p className="text-teal-50 mb-4">
                Detaillierte Analysen, Statistiken und Zielverfolgung
              </p>
              <div className="inline-flex items-center text-white font-semibold">
                Dashboard öffnen <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
